<template>
    <div class="user-share-button">
        <!-- Named by the visible slot label when one is passed (Global/actions),
             otherwise by aria-label. -->
        <button type="button" @click="share" :class="{ tapped: tapped }" :aria-label="$slots.default ? undefined : 'Share'">
            <SvgsShare />
            <slot />
        </button>
        <GlobalShareModal @close="tapped = false" v-if="tapped" :tapped="tapped" :url="url" :navobj="navObj" />
    </div>
</template>

<script setup>
    const props = defineProps({
        item: {
            type: Object,
            required: false,
        },
    });

    const { item } = toRefs(props);

    const tapped = ref(false);
    const route = useRoute();

    const url = ref('');

    const name = computed(() => {
        let itemName = '';
        itemName = props.item?.name || props?.fields?.Site;
        return itemName;
    });

    const navObj = computed(() => {
        if (import.meta.client) {
            const config = useRuntimeConfig();
            const isCustomTour = props.item.hasOwnProperty('sites') && props.item.hasOwnProperty('name');
            const isMobile = window.innerWidth < 768 ? true : false;
            const isMobileUrl = config.public.clientFrontend + (isCustomTour ? '/my-ohc/itineraries' : route.path);
            const isDesktopUrl = config.public.clientFrontend + '/open-house-chicago' + (isCustomTour ? '/my-ohc/itineraries' : route.path.replace('/iframe', ''));
            const urlPath = isMobile ? isMobileUrl : isMobileUrl;
            
            url.value = props.item.hasOwnProperty('sites') ? `${urlPath}?title=${encodeURIComponent(name.value)}&sites=${props.item?.sites}&shared=true` : urlPath;

            return {
                title: name.value,
                url: url.value,
            };
        }
    });

    async function share(e) {
        if (navigator.share) {
            try {
                await navigator.share(navObj.value);
            } catch (err) {
                if (!err.toString().includes('AbortError')) {
                    url.value = navObj.value.url;
                    tapped.value = true;
                }
            }
        } else {
            // fallback
            url.value = navObj.value.url;
            tapped.value = true;
        }

        gtmShared();
    }

    function gtmShared() {
        if (import.meta.client) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'shared',
                // No name_of_shared: for a custom itinerary that is the title the
                // user typed, which is personal data with no place in GTM.
                site_ids: item?.value?.sites?.toString() || 'Site(s) Unavailable',
                path: route.path,
            });
        }
    }
</script>
